<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa' && rol != 'admin-sucursal'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container grid-list-xl fluid v-else>
            <v-row wrap>
                <v-overlay :value="overlayDesgarga" >
                    <div class="align-center justify-center text-center">
                        <v-progress-circular
                            indeterminate
                            :size="100"
                            :width="7"
                            color="#2DB9D1"
                        >
                            <v-img
                                src="/static/icon/favicon.ico"
                                :width="60"
                            ></v-img>
                        </v-progress-circular>
                        <p>{{frase}}</p>
                    </div>
                </v-overlay>
                <v-overlay :value="dialogOverlayPuestos" :absolute="true">
                    <div class="align-center justify-center text-center">
                        <v-progress-circular
                            indeterminate
                            :size="100"
                            :width="7"
                            color="#2DB9D1"
                        >
                            <v-img
                                src="/static/icon/favicon.ico"
                                :width="60"
                            ></v-img>
                        </v-progress-circular>
                        <p class="mt-5">{{'Subiendo puestos'}} - {{porcentajePuestos}} %</p>
                        <p>Procesados {{puestosProcesados}} de {{totalPuestos}}</p>
                    </div>
                </v-overlay>
                <v-col xs="12" sm="12" md="12" xl="12" lg="12">
                    <data-table
                        ref="tablaPuestos"
                        :tableName="'Puestos'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :showAdvancedFilters="true"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;" v-if="permisos.create">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>
                        <template
                            v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa' || rol == 'admin-sucursal'"
                            slot="actionButtonsLeft"
                        >
                            <v-menu offset-y content-class="menuClassAcciones">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        dark
                                        class="btnAcciones pr-1 mr-3"
                                        v-bind="attrs"
                                        v-on="on"
                                        elevation="0"
                                    >
                                        Acciones 
                                        <template  v-for="(item,valor) in attrs" >
                                            <v-icon :key="valor" v-if="valor == 'aria-expanded' &&  item == 'true'" class="pl-2" color='#FFFFFF'>expand_less</v-icon>
                                            <v-icon :key="valor" v-if="valor == 'aria-expanded' &&  item == 'false'" class="pl-2" color='#FFFFFF'>expand_more</v-icon>
                                        </template>
                                    </v-btn>
                                    
                                </template>
                                <div class="btnAccionesContenedor">
                                    <div class="btnAccionesTitulo pb-6">
                                        <span>Layout de puestos</span>
                                    </div>

                                    <template v-if="rol == 'root' || rol == 'admin'">
                                        <div @click="abrirModalLayoutPuestos('descargar')" class="btnAccionesItem py-2">
                                            <span>Descargar layout</span>
                                        </div>
                                        <div @click="abrirModalLayoutPuestos('subir')" class="btnAccionesItem py-2">
                                            <span>Importar layout para agregar puestos</span><br />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div @click="layout()" class="btnAccionesItem py-2">
                                            <span>Descargar layout</span>
                                        </div>
                                        <div @click="modalLayout('subir')" class="btnAccionesItem py-2">
                                            <span>Importar layout para agregar puestos</span><br />
                                        </div>
                                    </template>
                                    <div class="btnAccionesTitulo pb-6">
                                        <span>Layout con información de los puestos</span>
                                    </div>
                                    <template v-if="rol == 'root' || rol == 'admin'">
                                        <div @click="abrirModalLayoutPuestos('exportarMasivo')" class="btnAccionesItem py-2">
                                            <span>Exportar carga masiva</span>
                                        </div>
                                        <div @click="abrirModalLayoutPuestos('updateMasivo')" class="btnAccionesItem py-2">
                                            <span>Actualizar carga masiva</span><br />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div @click="exportarPuestosMasivo()" class="btnAccionesItem py-2">
                                            <span>Exportar carga masiva</span>
                                        </div>
                                        <div @click="modalLayout('subirMasivo')" class="btnAccionesItem py-2">
                                            <span>Actualizar carga masiva</span><br />
                                        </div>
                                    </template>
                                </div>
                            </v-menu>
                        </template>
                        <template slot="filters">
                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                <v-text-field
                                    v-model="nombrePuesto"
                                    label="Nombre del puesto"
                                    outlined
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pt-4">
                                <template>
                                    <span class="rangoSalario">Rango de salario</span>
                                </template>
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <VuetifyMoney
                                    outlined
                                    label="Mínimo"
                                    v-model="sueldoMinimo"
                                    v-bind:options="options"
                                    ref="sueldoMinimo"
                                >
                                </VuetifyMoney>
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <VuetifyMoney
                                    outlined
                                    label="Máximo"
                                    v-model="sueldoMaximo"
                                    v-bind:options="options"
                                    ref="sueldoMaximo"
                                >
                                </VuetifyMoney>
                            </v-col>
                            <template v-if="rol == 'root'">
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="clientes"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Cliente"
                                        persistent-hint
                                        v-model="cliente_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin'">
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="empresas"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Empresa"
                                        persistent-hint
                                        v-model="empresa_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>
                            <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="sucursales"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Sucursal"
                                        persistent-hint
                                        v-model="sucursal_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>
                        </template>
                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td><div>{{ item.clave }}</div></td>
                                <td>
                                    <div class="tblPrincipal">
                                        {{ item.nombre_empresa }}
                                    </div>
                                    <div class="tblSecundario">
                                        {{ item.nombre_sucursal }}
                                    </div>
                                </td>
                                <td><div>{{ item.nombre }}</div></td>
                                <td><div>{{ formatoMoneda(item.sueldo) }}</div></td>
                                <td><div>{{ formatoMoneda(item.sueldo_maximo) }}</div></td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="permisos.delete">
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" class="botonHover" icon fab dark small @click="abrirModalDuplicar(item)">
                                                    <v-icon class="tamIconoBoton invertirColorBotones">content_copy</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Duplicar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="eliminar(item.id, item.nombre)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-row>
                <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>

                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <ValidationObserver ref="form" v-slot="{ invalid }">
                                <v-card-title class="justify-center card_titulo">
                                    <div class="headerModal">
                                        <img :src="imgModal" class="imgModal" />
                                        <h2 class="titleModal">{{ tituloModal }}</h2>
                                    </div>
                                </v-card-title>

                                <v-card-text class="card_texto">
                                    <div id="loadingModal" v-show="!finaliza_carga">
                                        <div id="loading">
                                            <v-progress-circular
                                                indeterminate
                                                :size="100"
                                                :width="7"
                                                color="blue"
                                            ></v-progress-circular>
                                        </div>
                                    </div>

                                    <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                        <v-divider class="divider"></v-divider>
                                        <v-row wrap>
                                            <template v-if="rol == 'root'">
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Cliente"
                                                            :items="clientes"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="cliente_value"
                                                            required
                                                            :error-messages="errors"
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Empresa"
                                                            :items="empresas"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="empresa_value"
                                                            required 
                                                            :error-messages="errors"
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Sucursal" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Sucursal"
                                                            :items="sucursales"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="sucursal_value"
                                                            required 
                                                            :error-messages="errors"
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                            </template>

                                            <template v-if="rol == 'admin'">
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Empresa"
                                                            :items="empresas"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="empresa_value"
                                                            required 
                                                            :error-messages="errors"
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Sucursal" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Sucursal"
                                                            :items="sucursales"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="sucursal_value"
                                                            required 
                                                            :error-messages="errors"
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                            </template>
                                            <template v-if="rol == 'admin-empresa'">
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Sucursal" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            label="Sucursal"
                                                            :items="sucursales"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            persistent-hint
                                                            v-model="sucursal_value"
                                                            required 
                                                            :error-messages="errors"
                                                        >
                                                        </v-autocomplete>
                                                    </ValidationProvider>
                                                </v-col>
                                            </template>
                                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Nombre" rules="required">
                                                    <v-text-field
                                                        outlined
                                                        label="Nombre"
                                                        v-model="puesto.nombre"
                                                        :error-messages="errors" 
                                                        required
                                                    >
                                                    </v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                            <!-- <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Objeto SYS" rules="required">
                                                    <v-text-field
                                                        outlined
                                                        label="Objeto SYS"
                                                        v-model="puesto.objetivo"
                                                        :error-messages="errors" 
                                                        required
                                                    >
                                                    </v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                                <v-text-field
                                                    outlined
                                                    label="Objeto IAS"
                                                    v-model="puesto.objetivo_ias"
                                                >
                                                </v-text-field>
                                            </v-col> -->
                                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Funciones" rules="required">
                                                    <v-textarea
                                                        rows="2"
                                                        outlined
                                                        label="Funciones"
                                                        v-model="puesto.funciones"
                                                        v-validate="'required'"
                                                        :error-messages="errors" 
                                                        required
                                                    >
                                                    </v-textarea>
                                                </ValidationProvider>
                                            </v-col>
                                            
                                            <v-col cols="12" xs="12" sm="6" md="5" lg="4" xl="4" class="py-0">
                                                <VuetifyMoney
                                                    rules="required"
                                                    outlined
                                                    label="Sueldo mínimo sugerido"
                                                    v-model="puesto.sueldo"
                                                    v-bind:options="options"
                                                    ref="sueldo"
                                                >
                                                </VuetifyMoney>
                                            </v-col>
                                            
                                            <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                                <VuetifyMoney
                                                    rules="required"
                                                    outlined
                                                    label="Sueldo máximo"
                                                    v-model="puesto.sueldo_maximo"
                                                    v-bind:options="options"
                                                    ref="sueldoMaximo"
                                                >
                                                </VuetifyMoney>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="6" md="3" lg="4" xl="4" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Plazas" rules="required|numeros_positivos">
                                                    <v-text-field
                                                        outlined
                                                        label="Plazas"
                                                        v-model="puesto.plazas"
                                                        v-mask="'######'"
                                                        :error-messages="errors" 
                                                        required
                                                    >
                                                    </v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                                    <button
                                        class="btnCerrar"
                                        @click="cerrarModal()"
                                        :disabled="loading_guardar"
                                    >
                                        Cancelar
                                    </button>
                                    <v-btn
                                        class="btnGuardar"
                                        @click="guardar()"
                                        :loading="loading_guardar"
                                        v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                                    >Guardar</v-btn>
                                </v-card-actions>

                                <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                                    <v-alert
                                        dense
                                        outlined
                                        type="error"
                                        
                                    >
                                        El usuario no tiene permiso para editar el registro.
                                    </v-alert>
                                </div>
                            </ValidationObserver>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-row>
        </template>

        <template>
            <v-dialog v-model="dialogLayout" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" style="display: none;" class="botonModal" id="btnModalLayout"></v-btn>
                </template>
                <v-card>
                    <ValidationObserver ref="form2" v-slot="{ invalid }">
                        <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                            <div class="headerModalStart">
                                <h2 class="titleModal_700_18">{{ tituloModal }}</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto">
                            <div id="padre" v-show="isLoadingLayout">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            
                            <v-container v-show="!isLoadingLayout" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Layout" rules="required">
                                            <v-file-input
                                                outlined
                                                label="Seleccionar el documento"
                                                v-model="archivo.archivo"
                                                accept=".xlsx"
                                                required 
                                                :error-messages="errors"
                                                prepend-icon=""
                                                append-icon="attach_file"
                                                id="fileDocument"
                                                @click:append="open"
                                            >
                                            </v-file-input>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button class="btnCerrar" @click="cerrarModal()" :disabled="isSaving">Cerrar</button>
                            <v-btn class="btnGuardar" v-if="accionLayout == 'subir'"  @click="guardarLayout()" :disabled="invalid" :loading="isSaving">Subir</v-btn>
                            <v-btn class="btnGuardar" v-if="accionLayout == 'subirMasivo'"  @click="actualizacionMasiva()" :disabled="invalid" :loading="isSaving">Subir</v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
        <template>
            <v-dialog v-model="dialogLayoutPuestos" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" style="display: none;" class="botonModal" id="btnModalLayoutEmpleados"></v-btn>
                </template>
                <v-card>
                    <ValidationObserver ref="form2" v-slot="{ invalid }">
                        <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                            <div class="headerModalStart">
                                <h2 class="titleModal_700_18">{{ tituloModal }}</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto">
                            <div id="padre" v-show="isLoadingLayout">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            
                            <v-container v-show="!isLoadingLayout" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col v-if="rol == 'root'" cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Cliente"
                                                :items="clientes"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="cliente_value"
                                                required
                                                :error-messages="errors" 
                                            >
                                            </v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin'" cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Empresa"
                                                :items="empresas"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="empresa_value"
                                                required 
                                                :error-messages="errors" 
                                            >
                                            </v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col v-if="accionLayout === 'subir' || accionLayout === 'updateMasivo'" cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Layout" rules="required">
                                            <v-file-input
                                                outlined
                                                label="Seleccionar el documento"
                                                v-model="archivo.archivo"
                                                accept=".xlsx"
                                                required 
                                                :error-messages="errors"
                                                prepend-icon=""
                                                append-icon="attach_file"
                                                id="fileDocument"
                                                @click:append="open"
                                            >
                                            </v-file-input>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button class="btnCerrar" @click="cerrarModal()" :disabled="isSaving">Cerrar</button>
                            <v-btn class="btnGuardar" v-if="accionLayout === 'subir'" @click="guardarLayout()" :disabled="invalid" :loading="isSaving">Subir</v-btn>
                            <v-btn class="btnGuardar" v-if="accionLayout === 'descargar'" @click="layout()" :disabled="invalid" :loading="isSaving">Descargar</v-btn>
                            <v-btn class="btnGuardar" v-if="accionLayout === 'exportarMasivo'" @click="exportarPuestosMasivo()" :disabled="invalid" :loading="isSaving">Descargar</v-btn>
                            <v-btn class="btnGuardar" v-if="accionLayout === 'updateMasivo'" @click=" actualizacionMasiva()" :disabled="invalid" :loading="isSaving">Subir</v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
        <template class="borde-card">
            <v-dialog v-model="dialogErrores" persistent max-width="950px" class="borde-card">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModalErrores"></v-btn>
                </template>
                <v-card class="borde-card">
                    <v-card-title class="padding_izquierdo padding_derecho padding_arriba">
                            <v-btn
                                @click="cerrarModalErrores()"
                                small
                                slot="activator"
                                icon
                                text
                                class="v-btn-cerrar modal-pull-right"
                                absolute
                                top
                                right
                            >
                                <v-icon class="icono-cerrar"></v-icon>
                            </v-btn>
                        <div class="headerModalStart">
                            <h2 class="titleModalErrores">Errores de puestos</h2>
                        </div>
                    </v-card-title>

                    <v-card-text class="padding_izquierdo padding_derecho padding_abajo">
                        <div id="padre" v-show="isLoadingError">
                            <div id="loading">
                                <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                            </div>
                        </div>
                        
                        <v-container v-show="!isLoadingError" grid-list-md id="contenedor">
                            <v-row class="pa-0 ma-0">
                                <v-col cols="12" xs="12" sm="12" md="12" class="pa-0 ma-0">
                                    <table class="tbl-errores">
                                        <thead class="tbl-header" v-if="erroresModal.length > 0">
                                            <tr>
                                                <th style="border-top-left-radius: 20px;" class="pl-7 errorth">Puesto</th>
                                                <th style="border-top-right-radius: 20px;" class="errorth">Tipo de error</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="observacionesModal.length == 0">
                                            <tr v-if="erroresModal.length == 0" >
                                                <td class="emptyTableErrores" colspan="2">
                                                    No hay elementos para mostrar
                                                </td>
                                            </tr>
                                            <template v-else v-for="(error, index) in erroresModal">
                                                <template>
                                                    <tr :key="index">
                                                        <td class="pl-7 errortd pt-4 pb-0">
                                                            <div class="textoTablaError01">{{error.nombre}}</div>
                                                        </td>
                                                        <td class="errortd"> <div class="textoTablaError03">{{error.comentarios}}</div> </td>
                                                    </tr>
                                                    <tr :key="'A'+index" class="trDivider"><div class="my-2"></div></tr>
                                                </template>
                                            </template>
                                        </tbody>
                                        <tbody v-else>
                                            <template v-for="(observacion, index) in observacionesModal">
                                                <template>
                                                    <tr :key="index">
                                                        <td class="pl-7 errortd pt-4 pb-0">
                                                            <div class="textoTablaError01">{{observacion}}</div>
                                                        </td>
                                                    </tr>
                                                    <tr :key="'A'+index" class="trDivider"><div class="my-2"></div></tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template>
            <v-dialog v-model="dialogDuplicar" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" style="display: none;" class="botonModal" id="btnModalLayoutEmpleados"></v-btn>
                </template>
                <v-card>
                    <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                        <div class="headerModalStart">
                            <h2 class="titleModal_700_18">{{ tituloModal }}</h2>
                        </div>
                    </v-card-title>
                    <v-card-text class="card_texto">
                        <div id="padre" v-show="isLoadingDuplicar">
                            <div id="loading">
                                <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                            </div>
                        </div>
                        
                        <v-container v-show="!isLoadingDuplicar" grid-list-md id="contenedor">
                            <v-divider class="divider"></v-divider>
                            <v-row>
                                <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                    <VuetifyMultipleAutocomplete
                                        outlined
                                        :items="itemsSucursales"
                                        :valorDefecto="modelSucursales"
                                        item_text="nombre"
                                        @dataMultiple="(data)=> modelSucursales = data"
                                        label="Sucursales"
                                        ref="multCocinas"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end card_accion">
                        <button class="btnCerrar" @click="cerrarModal()" :disabled="isSaving">Cerrar</button>
                        <v-btn class="btnGuardar" @click="duplicarPuesto()" :loading="isSaving">Duplicar</v-btn>    
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import apiPuestos from "../api/puestos";
import Datatable from "@/components/datatable/Datatable.vue";
import Notify from "@/plugins/notify";
import clienteAPi from "@/api/clientes";
import empresaApi from "@/api/empresas";
import sucursalApi from "@/api/sucursales";
import VuetifyMoney from '@/components/VuetifyMoneyValidate.vue';
import VuetifyMultipleAutocomplete from '@/components/VuetifyMultipleAutocomplete2.vue';

import env from '@/plugins/enviroment';
import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');

export default {
    components: {
        "data-table": Datatable,
        VuetifyMoney,
        VuetifyMultipleAutocomplete,
    },
    data() {
        return {
            url: "catalogo/puestos/find",
            columns: [
                {
                    label: "Clave",
                    name: "clave",
                    filterable: false
                },
                {
                    label: "Empresa",
                    name: "empresa",
                    filterable: true,
                },
                {
                    label: "Nombre del puesto",
                    name: "nombre",
                    filterable: true,
                },
                {
                    label: "Sueldo mínimo sugerido",
                    name: "sueldo",
                    filterable: true,
                },
                {
                    label: "Sueldo máximo",
                    name: "sueldo_maximo",
                    filterable: true,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align: 'center'
                },
            ],
            filters: {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                order_by        : 'id',
            },
            advancedSearch: {
                nombre: null,
            },
            loading_guardar     : false,
            loading             : true,
            dialog              : false,
            search              : "",
            datosLogin          : "",
            puesto              : {
                id              : null,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                nombre          : "",
                objetivo        : "",
                objetivo_ias    : null,
                funciones       : "",
                sueldo          : null,
                sueldo_maximo   : null,
                plazas          : null,
            },
            tituloModal        : "",
            finaliza_carga      : false,
            action              : "",
            clientes            : [],
            empresas            : [],
            sucursales          : [],
            cliente_value       : null,
            empresa_value       : null,
            sucursal_value      : null,
            rol                 : null,
            imgModal            : "",
            sueldoMinimo        : null,
            sueldoMaximo        : null,
            nombrePuesto        : null,
            options: {
                locale: "es-MX",
                prefix: "$",
                suffix: "",
                length: 11,
                precision: 2
            },
            frase                   :'Descargando archivo',
            overlayDesgarga         : false,
            archivo             : {
                archivo         : null,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                rol_name        : null,
                tipo            : 'gdth'
            },
            dialogLayout        : false,
            dialogLayoutPuestos : false,
            isLoadingLayout     : false,
            accionLayout        : 'descargar',
            isSaving            : false,
            erroresModal        : [],
            observacionesModal  : [],
            dialogErrores       : false,
            isLoadingError      : false,

            dialogOverlayPuestos: false,
            procesados          : 0,
            porcentajePuestos   : 0,
            totalPuestos        : 0,
            puestosProcesados   : 0,
            conError            : 0,

            dialogDuplicar          : false,
            isLoadingDuplicar       : false,
            itemsSucursales         : [],
            modelSucursales         : [],
            duplicarPuestoId        : null,
            permisos :{
                create: false,
                update: false,
                delete: false,
            }

        };
    },
    watch: {
        cliente_value: function(val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
        empresa_value: function(val) {
            if(val != null){
                this.cambiaEmpresa(val);
            }
        },
    },
    methods: {
        async listar() {
            await this.resetValues();
            this.loading = true;
            this.datosLogin = this.$session.get("usuario");
            this.socketProcesandoPuestos();
            let param = { activo: true, paginate: false };
            this.rol = this.datosLogin.rol.name;
            if (this.rol == "admin") {
                this.filters.cliente_id = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.filters.empresa_id = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                this.filters.sucursal_id = this.datosLogin.sucursal_id;
            }
        },
        async loadModalData() {
            await this.resetValues();

            if (this.rol == "root") {
                this.getClientes();
            } else if (this.rol == "admin") {
                this.cambiaCliente(this.datosLogin.cliente_id);
                this.cliente_value = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.cambiaEmpresa(this.datosLogin.empresa_id);
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                this.puesto.cliente_id = this.cliente_value = this.datosLogin.cliente_id;
                this.puesto.empresa_id = this.empresa_value = this.datosLogin.empresa_id;
                this.puesto.sucursal_id = this.sucursal_value = this.datosLogin.sucursal_id;
            }
        },
        setFilters() {

            let nombre      = this.nombrePuesto;
            let cliente_id  = this.cliente_value;
            let empresa_id  = this.empresa_value;
            let sucursal_id = this.sucursal_value;
            let sueldoMinimo= this.sueldoMinimo; 
            let sueldoMaximo= this.sueldoMaximo; 
            let filterParams = {
                nombre      : nombre,
                cliente_id  : cliente_id,
                empresa_id  : empresa_id,
                sucursal_id : sucursal_id,
                min_sueldo  : sueldoMinimo,
                max_sueldo  : sueldoMaximo,
            };
            let defaultParams = {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                order_by        : 'id',
            };
            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }
            this.filters = defaultParams;
            this.nombrePuesto   = null;
            this.cliente_value  = null;
            this.empresa_value  = null;
            this.sucursal_value = null;
            this.sueldoMinimo   = null;
            this.sueldoMaximo   = null;
        },
        abrirModal(accion, item = null) {
            this.errors.clear();
            this.accion = accion;
            if (accion == "add") {
                this.imgModal = "/static/modal/puestoCreate.svg";
                this.tituloModal = "Registrar puesto";
            } else {
                this.imgModal           = "/static/modal/puestoUpdate.svg";
                this.tituloModal       = "Actualizar puesto";
                this.puesto.id          = item.id;
                this.puesto.cliente_id  = item.cliente_id;
                this.puesto.empresa_id  = item.empresa_id;
                this.puesto.sucursal_id = item.sucursal_id;
                this.puesto.nombre      = item.nombre;
                this.puesto.objetivo    = item.objetivo;
                this.puesto.objetivo_ias= item.objetivo_ias;
                this.puesto.funciones   = item.funciones;
                this.puesto.sueldo      = item.sueldo;
                this.puesto.sueldo_maximo = item.sueldo_maximo;
                this.puesto.plazas      = item.plazas;
                this.cliente_value      = item.cliente_id;
                this.empresa_value      = item.empresa_id;
                this.sucursal_value     = item.sucursal_id;
            }
            this.finaliza_carga = true;
            if (this.rol == "root") {
                this.getClientes();
            }
            if (this.rol == "admin") {
                this.cambiaCliente(this.datosLogin.cliente_id, this.accion);
                this.cliente_value = this.datosLogin.cliente_id;
            }
            if (this.rol == "admin-empresa") {
                this.cambiaEmpresa(this.datosLogin.empresa_id, this.accion);
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }
            if (this.rol == "admin-sucursal"){
                this.puesto.cliente_id = this.cliente_value = this.datosLogin.cliente_id;
                this.puesto.empresa_id = this.empresa_value = this.datosLogin.empresa_id;
                this.puesto.sucursal_id = this.sucursal_value = this.datosLogin.sucursal_id;
            }
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },
        guardar() {
            this.$refs.form.validate().then(result => {
                //this.$validator.validate().then((result) => {
                if (result) {
                    this.puesto.cliente_id = this.cliente_value;
                    this.puesto.empresa_id = this.empresa_value;
                    this.puesto.sucursal_id = this.sucursal_value;       
                    this.loading_guardar = true;
                    if (this.accion === "add") {
                        apiPuestos
                        .addPuesto(this.puesto)
                        .then((response) => {
                            this.$refs.tablaPuestos.getData();
                            this.respuesta_ok(
                            "Se creó el nuevo puesto satisfactoriamente."
                            );
                            this.cerrarModal();
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    } else if (this.accion === "update") {
                        apiPuestos
                        .updatePuesto(this.puesto)
                        .then((response) => {
                            this.$refs.tablaPuestos.getData();
                            this.respuesta_ok("Se actualizo el puesto satisfactoriamente.");
                            this.cerrarModal();
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        cerrarModal() {
            this.dialog = false;
            this.isSaving           = false;
            this.dialogLayout       = false;
            this.dialogLayoutPuestos= false;
            this.isLoadingLayout    = false;

            this.dialogDuplicar      = false;
            this.isLoadingDuplicar   = false;

            this.resetValues();
        },
        async resetValues() {
            this.puesto         = {
                id              : null,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                nombre          : "",
                objetivo        : "",
                objetivo_ias    : null,
                funciones       : "",
                sueldo          : null,
                sueldo_maximo   : null,
                plazas          : null,
            };
            this.cliente_value  = null;
            this.empresa_value  = null;
            this.sucursal_value = null;
            this.loading_guardar= false;
            this.sueldoMinimo   = null;
            this.sueldoMaximo   = null;
            this.nombrePuesto   = null;
            this.clientes       = [];
            this.empresas       = [];
            this.sucursales     = [];

            this.archivo        = {
                archivo         : null,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                rol_name        : null,
                tipo            : 'gdth'
            };

            this.itemsSucursales  = [];
            this.modelSucursales  = [];
            this.duplicarPuestoId = null;

            this.isSaving       =false;
            this.$nextTick(() => {
                if(this.$refs.form != undefined || this.$refs.form != null){
                    this.$refs.form.reset();
                } 
            });

            this.$nextTick(() => {
                if(this.$refs.form2 != undefined || this.$refs.form2 != null){
                    this.$refs.form2.reset();
                } 
            });

        },
        eliminar(id, nombre) {
            let self = this;
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el puesto " + nombre + "?",
                "Eliminar",
                () => {
                    apiPuestos.deletePuesto(id).then((response) => {
                        self.listar();
                        self.$refs.tablaPuestos.getData();
                        this.respuesta_ok("El puesto ha sido eliminado satisfactoriamente");
                    })
                    .catch((err) => {
                        console.log(err);
                        Notify.Error("Eliminar Puesto", "Ocurrió un error al eliminar el puesto.");
                    });
                }
            );
        },
        getClientes(cliente = null) {
            let param = { activo: true, paginate: false };
            clienteAPi.getClientes(param).then((response) => {
                this.clientes = response.data;
            })
            .catch((err) => {
                Notify.ErrorToast("No se pudieron cargar los clientes.");
            });
        },
        cambiaCliente(id, cliente = null) {
            if (this.puesto.cliente_id != id) {
                //this.empresa_value = null;
                this.puesto.empresa_id = null;
            }

            let parametros = { activo: true, paginate: false, cliente_id: id };
            empresaApi.getEmpresas(parametros).then((response) => {
                this.empresas = response.data;
                if (this.puesto.empresa_id != null) {
                    this.empresa_value = this.puesto.empresa_id;
                }
            })
            .catch((err) => {
                Notify.ErrorToast("No se pudieron cargar las empresas.");
            });
        },
        cambiaEmpresa(id, sucursal = null) {
            if (this.puesto.empresa_id != id) {
                this.sucursal_value = null;
                this.puesto.sucursal_id = null;
            }
            let parametros = { activo: true, paginate: false, empresa_id: id };
            sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;
                if (this.puesto.sucursal_id != null) {
                    this.sucursal_value = this.puesto.sucursal_id;
                }
            })
            .catch((err) => {
                Notify.ErrorToast("No se pudieron cargar las sucursales.");
            });
        },

        respuesta_error(err) {
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj) {
            this.listar();
            this.cerrarModal();
            Notify.Success("Operación exitosa", msj);
        },
        formatoMoneda(value){
            const formatter = new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN',
            })
            return formatter.format(value)
        },
        open(){
            document.getElementById("fileDocument").click();
        },
        abrirModalLayoutPuestos(accion){
            this.isLoadingLayout = true;
            this.accionLayout = accion;
            this.dialogLayoutPuestos = true;
            if(accion === 'descargar' ){
                this.tituloModal  = 'Descargar layout para agregar puestos';
            }
            else if(accion === 'subir'){
                this.tituloModal  = 'Subir layout para agregar puestos';
            }
            else if (accion === 'exportar'){
                this.tituloModal  = 'Exportar layout de puestos';
            }
            else if(accion == 'exportarMasivo'){
                this.tituloModal = 'Exportar layout de puestos'
            }
            else if(accion == 'updateMasivo'){
                this.tituloModal = 'Actualización masiva'
            }
            if (this.rol == "admin") {
                this.archivo.cliente_id = this.datosLogin.cliente_id;
                this.cliente_value = this.datosLogin.cliente_id;
            }
            if(this.rol == "root"){
                this.getClientes();
            }
            this.isLoadingLayout = false;
            this.$nextTick(() => {
                if(this.$refs.form2 != undefined || this.$refs.form2 != null){
                    this.$refs.form2.reset();
                } 
            });
        },
        modalLayout(accion) {
            this.accionLayout = accion
            this.archivo.cliente_id = this.datosLogin.cliente_id;
            this.archivo.empresa_id = this.datosLogin.empresa_id;
            
            if(accion == 'subir'){
                this.tituloModal = "Subir layout para agregar puestos";
            }else if(accion == 'subirMasivo'){
                this.tituloModal = "Actualización masiva"
            }
            if (this.rol == "admin-sucursal") {
                this.archivo.sucursal_id = this.datosLogin.sucursal_id;
            }
            this.archivo.rol_name = this.datosLogin.rol.name;

            setTimeout(function() {
                document.getElementById("btnModalLayout").click();
            }, 300);
        },
        async layout() {
            let self = this;
            let url = "catalogo/puestos/layout";
            const FileDownload = require("js-file-download");
            var today = new Date();
            let nombre;
            if (this.rol == "admin" || this.rol == "root") {
                this.isSaving = true;
                nombre =
                    "layout_de_importacion_de_puestos_" +
                    today.getDate() +
                    "_" +
                    (today.getMonth() + 1) +
                    "_" +
                    today.getFullYear() +
                    "_" +
                    today.getHours() +
                    "-" +
                    today.getMinutes() +
                    "-" +
                    today.getSeconds() +
                    ".xlsx";
                var object1 = {
                    rol_name: "admin-empresa",
                    cliente_id: this.cliente_value,
                    empresa_id: this.empresa_value,
                };
            }
            if (this.rol == "admin-empresa") {
                this.overlayDesgarga = true;
                nombre =
                    "layout_de_importacion_de_puestos_" +
                    today.getDate() +
                    "_" +
                    (today.getMonth() + 1) +
                    "_" +
                    today.getFullYear() +
                    "_" +
                    today.getHours() +
                    "-" +
                    today.getMinutes() +
                    "-" +
                    today.getSeconds() +
                    ".xlsx";
                var object1 = {
                    rol_name: this.rol,
                    cliente_id: this.datosLogin.cliente_id,
                    empresa_id: this.datosLogin.empresa_id,
                };
            }
            if (this.rol == "admin-sucursal") {
                this.overlayDesgarga = true;
                nombre =
                   "layout_de_importacion_de_puestos_" +
                    today.getDate() +
                    "_" +
                    (today.getMonth() + 1) +
                    "_" +
                    today.getFullYear() +
                    "_" +
                    today.getHours() +
                    "-" +
                    today.getMinutes() +
                    "-" +
                    today.getSeconds() +
                    ".xlsx";
                var object1 = {
                    rol_name: this.rol,
                    cliente_id: this.datosLogin.cliente_id,
                    empresa_id: this.datosLogin.empresa_id,
                    sucursal_id: this.datosLogin.sucursal_id,
                };
            }
            object1.sistema = "gdth";
            try {
                await Vue.axios({
                    method: "GET",
                    responseType: "blob",
                    url: url,
                    params: object1
                }).then((response, status, xhr) => {
                    FileDownload(response.data, nombre);
                    this.cerrarModal();
                    this.overlayDesgarga = false;
                });
            } catch (e) {
                this.isSaving = false;
                console.log(e);
            }
        },
        guardarLayout() {
            let self = this;
            this.$refs.form2.validate().then(success => {
                this.isSaving = true;
                if(!success) {
                    this.isSaving = false;
                    return;
                }
                if(this.rol == "root" || this.rol == "admin"){
                    this.archivo.cliente_id = this.cliente_value;
                    this.archivo.empresa_id = this.empresa_value;
                    this.archivo.rol_name   = "admin-empresa";
                }
                let formData = new FormData();
                formData.append("archivo", this.archivo.archivo);
                formData.append("cliente_id", this.archivo.cliente_id);
                formData.append("empresa_id", this.archivo.empresa_id);
                formData.append("tipo", this.archivo.tipo);

                if (this.rol == "admin-sucursal") {
                    formData.append("sucursal_id", this.archivo.sucursal_id);
                }

                formData.append("rol_name", this.archivo.rol_name);
                formData.append("usuario_id", this.datosLogin.id);
                let url = "catalogo/puestos/importar";
                const FileDownload = require("js-file-download");
                const config = {
                    headers: {
                        responseType: "blob"
                    }
                };
                
                Vue.axios({
                    method: "post",
                    url: "catalogo/puestos/importar",
                    data: formData,
                    config: { headers: { "Content-Type": "multipart/form-data" } }
                })
                .then(function(response) {
                    if (response.status == 200) {
                        //Notify.Success("Operación exitosa", "Se ha realizado la operación correctamente.");
                        self.cerrarModal();
                        self.dialogOverlayPuestos = true;
                        //self.$refs.tablaPuestos.getData();
                        
                    } else if (response.status == 202) {
                        Notify.ErrorToast("Se encontraron errores en los datos");
                        self.erroresModal = response.data;
                        self.dialogErrores = true;
                        self.cerrarModal();
                        self.$refs.tablaPuestos.getData();
                        
                    } else {
                        self.cerrarModal();
                        self.$refs.tablaPuestos.getData();
                    }
                })
                .catch(err => {
                    this.isSaving = false;
                    self.dialogOverlayPuestos = false;
                    Notify.ErrorToast("Error al subir archivo.");
                    this.$refs.tablaPuestos.getData();
                });
            });
        },
        cerrarModalErrores(){
            this.dialogErrores = false;
            this.erroresModal = [];
            this.observacionesModal = []
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
        socketProcesandoPuestos(){

            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: 'ASDASD2121',
                wsHost: env.serverURL.url,
                wsPort: env.pusherPort,
                wssPort: env.pusherPort,
                forceTLS: env.serverURL.tls,
                disableStats: true,
                enabledTransports: ['ws', 'wss']
            });

            window.Echo.channel(`progreso-importar-puesto-${this.datosLogin.id}`).listen('ImportarPuestoProgress', (e) =>{
                this.dialogOverlayPuestos = true;
                this.porcentajePuestos = e.message.porcentaje;
                this.totalPuestos = e.message.total;
                this.puestosProcesados = e.message.procesados;
                if(e.message.porcentaje == 100){
                    this.procesados = e.message.procesados;
                    this.conError = e.message.errores;  

                    if(e.message.errores.length == 0){
                        this.dialogOverlayPuestos = false;
                        Notify.Success("Operación exitosa");
                        this.$refs.tablaPuestos.getData();
                    }else{
                        this.dialogOverlayPuestos = false;
                        this.erroresModal = e.message.errores;
                        this.dialogErrores = true;
                        this.$refs.tablaPuestos.getData();
                    }

                }
                
                setTimeout(() => {
                    this.resetProgresoPuestos();
                }, 5000);

            })

        },
        resetProgresoPuestos(){
            this.porcentajePuestos = 0;
            this.totalPuestos = 0;
            this.puestosProcesados = 0;
            this.procesados = 0;
            this.conError = 0;
        },
        async getSucursales(data){
            let parametros = { activo:true, paginate: false, empresa_id: data.empresa_id }
            await sucursalApi.getSucursales(parametros).then((response)=>{
                let format = response.data
                this.itemsSucursales = format.map(item => {
                    if(item.id != data.sucursal_id){
                        return item;
                    } 
                } );
            })
            .catch(err => {
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            });
        },
        async abrirModalDuplicar(data){
            this.tituloModal = "Duplicar puesto";
            this.dialogDuplicar = true;
            this.isLoadingDuplicar = true;
            await this.getSucursales(data);
            this.isLoadingDuplicar = false;
            this.duplicarPuestoId = data.id;

        },
        duplicarPuesto(){
            this.isSaving =  true;
            if(this.modelSucursales.length == 0){
                Notify.ErrorToast("Selecciona al menos una sucursal.");
                this.isSaving =  false;
                return;
            }

            let parametros = {
                puesto_id: this.duplicarPuestoId, 
                sucursales: this.modelSucursales 
            }
            apiPuestos.duplicar(parametros).then((response) => {
                this.isSaving = false;
                Notify.Success("Operación exitosa", "El Puesto se duplico satisfactoriamente.");
                this.$refs.tablaPuestos.getData();
                this.cerrarModal();
            })
            .catch(err => {
                this.isSaving = false;
                if(typeof err.response.data.error === 'string'){
                    Notify.ErrorToast(err.response.data.error);
                }else{
                    let error = Object.values(err.response.data.error);
                    let leyenda = ``;

                    for (var i = 0; i < error.length; i++) {
                        leyenda+= `* ` + error[i] + `\n`;
                    }

                    Notify.ErrorToast(leyenda);
                }
            });
        },

        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("catalogo.puestos.store")
            this.permisos.update = permisosStorage.includes("catalogo.puestos.update")
            this.permisos.delete = permisosStorage.includes("catalogo.puestos.delete")
        },

        exportarPuestosMasivo() {
            this.overlayDesgarga = true
            let url = "catalogo/puestos/export-masivo"
            const FileDownload = require("js-file-download")
            let today = new Date()
            let nombre
            this.isSaving = true

            if (this.rol == "root" || this.rol == "admin") {
                this.$refs.form2.validate().then((success) => {
                    if (!success) {
                        this.overlayDesgarga = false;
                        this.isSaving = false;
                        return
                    }
                    nombre = `puestos_${today.getDate()}_${today.getMonth() + 1}_${today.getFullYear()}_${today.getHours()}_${today.getMinutes()}_${today.getSeconds()}.xlsx`

                    let parametros = {
                        rol_name: 'admin-empresa',
                        cliente_id: this.cliente_value,
                        empresa_id: this.empresa_value,
                        sistema: 'gdth'
                    }

                    try {
                        Vue.axios({
                            method: "GET",
                            responseType: "blob",
                            url: url,
                            params: parametros
                        }).then((response) => {
                            if (response.status == 200) {
                                FileDownload(response.data, nombre)
                                this.overlayDesgarga = false
                                this.cerrarModal()
                            } else {
                                Notify.ErrorToast("Algo ha salido mal, intenta de nuevo o consulta a soporte técnico.")
                                this.overlayDesgarga = false
                                this.cerrarModal()
                            }
                        })
                    } catch (error) {
                        console.log('Hubo un error:', error)
                        this.overlayDesgarga = false
                        this.cerrarModal()
                    }
                })
            } else {
                nombre = `puestos_${today.getDate()}_${today.getMonth() + 1}_${today.getFullYear()}_${today.getHours()}_${today.getMinutes()}_${today.getSeconds()}.xlsx`

                let parametros = {
                    rol_name: 'admin-empresa',
                    cliente_id: this.datosLogin.cliente_id,
                    empresa_id: this.datosLogin.empresa_id,
                    sistema: 'gdth'
                }

                if(this.rol == "admin-sucursal"){
                    parametros.rol_name = 'admin-sucursal',
                    parametros.sucursal_id = this.datosLogin.sucursal_id
                }

                try {
                    Vue.axios({
                        method: "GET",
                        responseType: "blob",
                        url: url,
                        params: parametros
                    }).then((response) => {
                        if (response.status == 200) {
                            FileDownload(response.data, nombre)
                            this.overlayDesgarga = false
                            this.cerrarModal()
                        } else {
                            Notify.ErrorToast("Algo ha salido mal, intenta de nuevo o consulta a soporte técnico.")
                            this.overlayDesgarga = false
                            this.cerrarModal()
                        }
                    })
                } catch (error) {
                    console.log('Hubo un error:', error)
                    this.overlayDesgarga = false
                    this.cerrarModal()
                }
            }

        },

        actualizacionMasiva(){
            this.$refs.form2.validate().then((success) => {
                this.isSaving = true
                if(!success){
                    this.isSaving = false
                    return
                }

                let formData = new FormData();
        
                if(this.rol == "root" || this.rol == "admin"){
                    this.archivo.cliente_id = this.cliente_value
                    this.archivo.empresa_id = this.empresa_value
                    this.archivo.rol_name = "admin-empresa"
                    formData.append("empresa_id", this.archivo.empresa_id)
                }
                else if(this.rol == "admin-empresa"){
                    this.archivo.cliente_id = this.datosLogin.cliente_id;
                    this.archivo.empresa_id = this.datosLogin.empresa_id;
                    formData.append("empresa_id", this.archivo.empresa_id)
                }
                else if(this.rol == "admin-sucursal"){
                    this.archivo.cliente_id = this.datosLogin.cliente_id;
                    formData.append("empresa_id", this.datosLogin.empresa_id)
                    formData.append("sucursal_id", this.datosLogin.sucursal_id)
                }
                
                formData.append("archivo", this.archivo.archivo)
                formData.append("cliente_id", this.archivo.cliente_id)
                formData.append("sistema", "gdth")
                formData.append("rol_name", this.archivo.rol_name)

                apiPuestos.updateMasivo(formData).then((response) => {
                    this.cerrarModal()
                    if(response.status == 200){
                        this.cerrarModal()
                        //Notify.Success("Operación exitosa","Se actualizaron correctamente los puestos")
                        this.$refs.tablaPuestos.getData()
                    }/* else if(response.status == 202){
                        this.observacionesModal = response.data.observaciones
                        this.dialogErrores = true
                        this.cerrarModal()
                        this.$refs.tablaPuestos.getData()
                    } */
                }).catch((err) => {
                    this.cerrarModal()
                    console.log(err)
                    //Notify.ErrorToast("Error con el archivo subido.")
                })
            })
        },
    },
    created() {
        this.listar();
        this.permisosVista();
    },
};
</script>
<style scoped>
    #loading {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .rangoSalario{
        font-family: 'Montserrat' !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 15px !important;
        color: #1E2245 !important;
}
    .menuClassAcciones{
        /* box-shadow: none; */
        border-radius: 10px!important;
        margin-top:15px;
    }
    .btnAcciones {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
    }
    .btnAcciones:hover {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        box-shadow: 0px 5px 8px rgba(26, 30, 66, 0.2);
        -webkit-transform: translatey(-1px);
        transform: translatey(-1px);
    }
    .btnAccionesContenedor {
        width: 300px;
        height: auto;
        padding-block: 30px;
        background-color: #FFF;
    }
    div.btnAccionesTitulo {
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesTitulo span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
        color: #1E2245;
    }
    div.btnAccionesItem {
        width: 100%;
        cursor: pointer;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesItem span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    div.btnAccionesItem:hover {
        background: #F6F6F8;
    }

    #btnModalErrores{
        display: none;
    }

    .titleModalErrores{
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 18px;
        letter-spacing: 0.1px;
        color: #444975;
    }
    .emptyTableErrores{
        padding-top: 50px !important;
        padding-bottom: 50px !important;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center !important;
        color: #c5c5c5;
    }
    .tbl-errores {
        border-collapse: collapse;
        width: 100%;
        margin-top: 15px;
        /* white-space: nowrap; */
        overflow-x: scroll;
        overflow-y: scroll;
    }

    .tbl-errores .tbl-header {
        background: #F6F6F6;
        border-radius: 10px;
        height: 58px;
    }
    .errorth {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        color: #828282;
        line-height: 20px;
        padding: 8px;
        text-align: left !important;
    }
    .errortd {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        color: #96999A;
        line-height: 15px;
        padding: 8px;
        text-align: left !important;
    }
    .textoTablaError01{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #1E2245;
        text-align: left !important;
    }
    .textoTablaError02{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #828282;
        text-align: left !important;
    }
    .textoTablaError03{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        color: #EB5757;
        line-height: 17px;
        text-align: left !important;
    }
    .trDivider{
        border-bottom-style: solid; 
        border-bottom-width: 1px;
        border-bottom-color: #C4C4C4;
    }
</style>